import Icon from '@/common/components/Icon';
import React, { useContext, useEffect, useState } from 'react';
import TodoList from './components/todoLIst/TodoList';
import { getAllTodos } from '@/API/repositories/todo';
import { useRequestsContext } from '@/common/hooks/requestHook';
import { sortTodosByDateAndPriority } from './helpers/sortTodosByDateAndPriority';
import { Colors } from '@/common/colors/colors';
import { useMessageQueueContext } from '@/common/hooks/useMessageQueue';
import { NotSeenWrapper } from '@/pages/consultant/infobar/todoView/TodoView.styled';
import { AuthContext } from '@/common/contexts/authContext';


function TodoView() {
	const { authUser } = useContext(AuthContext);

	const [isTodoListOpen, setIsTodoListOpen] = useState(false);
	const [todos, setTodos] = useState();
	const [notRead, setNotRead] = useState();

	const currentUserId = authUser.id;

	const { addMessage } = useMessageQueueContext();
	const { makeRequest } = useRequestsContext();

	const loadData = async () => {
		const response = await makeRequest(getAllTodos);

		if (!response?.data) {
			return addMessage("Can't load todos");
		}

		const data = response.data;

		const notReadTodos = [];

		data.forEach((todosGroup) => {
			const filteredGroup =
				todosGroup?.data?.filter((todo) =>
					todo.messages?.some(
						(message) =>
							!message?.seen?.includes(currentUserId) &&
							todo.created_by === currentUserId,
					),
				) || [];
			notReadTodos.push(...filteredGroup);
		});

		if (notReadTodos?.length) {
			addMessage('You have some updates in todo list', 'error');
		}
		setNotRead(() => notReadTodos.map((todo) => todo._id));

		response.data.forEach((todosGroup) => {
			todosGroup.data = sortTodosByDateAndPriority(todosGroup.data);
		});

		setTodos(() => response.data);
	};

	useEffect(() => {
		const intervalId = setInterval(() => loadData(), 60000);

		return () => {
			clearInterval(intervalId);
		};
	}, []);

	useEffect(() => {
		loadData();
	}, []);

	return (
		<>
			<div
				onClick={() => setIsTodoListOpen(true)}
				style={{ position: 'relative', cursor: 'pointer' }}
			>
				<Icon
					name='list-check'
					size={20}
					color={notRead?.length ? Colors.red : Colors.darkBlue}
				/>
				{!!notRead?.length && (
					<NotSeenWrapper>{notRead?.length}</NotSeenWrapper>
				)}
			</div>
			{isTodoListOpen && (
				<TodoList
					notRead={notRead}
					loadData={loadData}
					setTodos={setTodos}
					todos={todos}
					setIsOpen={setIsTodoListOpen}
				/>
			)}
		</>
	);
}

export default TodoView;
